/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

//import { IProductRefinerHierarchy } from '@msdyn365-commerce/commerce-entities';
import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';
import { SortingInfo } from '@msdyn365-commerce/retail-proxy';
//import { ProductPrice, ProductRefinerValue, ProductSearchResult, SimpleProduct, SortingInfo } from '@msdyn365-commerce/retail-proxy';
import { observable } from 'mobx';
import { ILobasTableRefinerHierarchy, ILobasTableRefinerValue } from '../modules/components/lobas-table';
import { IArticle } from './DataServiceEntities.g';

/**
 * Export listPageType.
 */
export type listPageType = 'Category' | 'Search' | 'Unknown';

/**
 * ListPageState class.
 */
export class ListPageState {
    @observable public activeFilters: ILobasTableRefinerValue[] | null = null;

    /** Tags selected in the interactive refiner panel (OR semantics). */
    @observable public activeTags: string[] = [];

    //@observable public activeProducts: ProductSearchResult[] = [];

    @observable public activeArticles: IArticle[] = [];

    @observable public sortingCritera: SortingInfo | null = null;

    @observable public currentPageNumber: number | null = null;

    @observable public refiners: ILobasTableRefinerHierarchy[] | null = null;

    @observable public totalTableCount: number | undefined;

    @observable public pageSize: number = 1000;

    @observable public pageType: listPageType = 'Unknown';

    //@observable public featureProduct: SimpleProduct | null = null;

    //@observable public productPrices: ProductPrice[] | undefined = [];
}

/**
 * ListPageStateInput - action input.
 */
export class ListPageStateInput implements IActionInput {
    public getCacheKey = () => 'ListPageState';

    public getCacheObjectType = () => 'ListPageState';

    public dataCacheType = (): CacheType => 'request';
}

export async function listPageStateAction(input: ListPageStateInput, ctx: IActionContext): Promise<ListPageState> {
    return new ListPageState();
}

/**
 * Create new input for create action.
 * @param inputData
 */
export const createListPageInput = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return new ListPageStateInput();
};

/**
 * ListPageState - create action.
 */
export default createObservableDataAction<ListPageState>({
    action: <IAction<ListPageState>>listPageStateAction,
    input: createListPageInput
});
